import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-text-avatar',
    templateUrl: './text-avatar.component.html',
    styleUrl: './text-avatar.component.scss',
    imports: [MatButtonModule, CommonModule]
})
export class TextAvatarComponent implements OnChanges {
  @Input() getCellStyles: (displayName: string) => any;
  @Input() name: string | undefined;
  displayName: string;

  ngOnChanges(changes: SimpleChanges) {
    // total only get from dataSource if data not from API
    // check dataSource change and have value
    if (changes['name']) {
      if (this.name) {
        if (!this.name) this.displayName = '';
        const nameParts = this.name.trim().split(' ');
        // "Nguyen An Phuc" and return the initials (e.g., "NA")
        this.displayName =
          nameParts.length > 1 ? (nameParts[0].charAt(0) + nameParts[1].charAt(0)).toUpperCase() : nameParts[0].charAt(0).toUpperCase();
      }
    }
  }
}
